import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import styles from './AutoCarousel.module.sass';
import './SlickOverrides.sass';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';

function Image(props) {
  useEffect(() => {
    window.lazyLoad.update();
  }, []);

  const { onClick, image, title } = props;

  return (
    <ClickableDiv className={styles['image-wrapper']} onClick={onClick}>
      <div className={styles.image}>
        <picture>
          <source suppressHydrationWarning data-srcset={image.urlWebp} srcSet={image.placeholderWebp} type="image/webp" />
          <img suppressHydrationWarning className="lazyload" data-src={image.url} src={image.url} alt={title} />
        </picture>
      </div>
    </ClickableDiv>
  );
}

Image.propTypes = {
  onClick: PropTypes.func.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string,
    urlWebp: PropTypes.string,
    placeholder: PropTypes.string,
    placeholderWebp: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

function AutoCarousel(props) {
  const [isShown, setIsShown] = useState(false);

  const {
    carouselImages, campaignImage, imagePlaceholder, title,
  } = props;

  return (
    <div
      className={styles.image}
      onMouseEnter={() => setIsShown(true)}
    >
      <img suppressHydrationWarning className="lazyload blur" src={imagePlaceholder} data-src={campaignImage} alt={title} />
      {isShown && carouselImages && (
      <div
        className="autocarousel"
        onMouseLeave={() => setIsShown(false)}
      >
        <Slider
          infinite
          speed={0}
          slidesToShow={1}
          slidesToScroll={1}
          arrows={false}
          autoplay
          autoplaySpeed={1000}
          pauseOnHover={false}
          pauseOnFocus={false}
          className={styles.slider}
        >
          {carouselImages.map((image) => (
            <div key={image} className={styles['carousel-image']}>
              <Image
                image={image}
                onClick={() => {}}
                title={title}
              />
            </div>
          ))}
          <div className={styles['image-wrapper']}>
            <div className={styles.image}>
              <img src={campaignImage} alt={title} />
            </div>
          </div>
        </Slider>
      </div>
      )}
    </div>
  );
}

AutoCarousel.propTypes = {
  carouselImages: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    placeholder: PropTypes.string,
  })).isRequired,
  campaignImage: PropTypes.string.isRequired,
  imagePlaceholder: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default AutoCarousel;
